import { Controller } from '@hotwired/stimulus'

import { createApp } from '@app/adapters/create-app'
import WorkflowProgress from '@app/application/workflows/screens/workflow-review/components/workflow-progress.vue'

export default class extends Controller {
  static values = {
    isLocked: Boolean,
    lastId: Number,
    ledgerId: Number,
    showLegend: Boolean,
    workflowId: Number,
  }

  declare isLockedValue: boolean
  declare lastIdValue: number
  declare ledgerIdValue: number
  declare showLegendValue: boolean
  declare workflowIdValue: number

  connect(): void {
    createApp(
      WorkflowProgress,
      {
        color: this.isLockedValue ? 'text' : 'primary',
        disabled: this.isLockedValue,
        lastId: this.lastIdValue,
        ledgerId: this.ledgerIdValue,
        showLegend: this.showLegendValue,
        showTotalPercentage: true,
        size: 'medium',
        workflowId: this.workflowIdValue,
      },
      {
        singletonId: `workflow-progress-${this.workflowIdValue}-${this.ledgerIdValue}`,
      }
    ).mount(this.element)
  }
}
